import * as React from "react";
import { UitkSubheading } from "uitk-react-text";
import { UitkLink } from "uitk-react-link";
import { Travelers } from "src/components/shared/Travelers/Travelers";
import { Dates } from "src/components/shared/Dates/Dates";
import { observer } from "mobx-react";
import { Duration } from "components/shared/Duration/Duration";
import { Locations3PP } from "src/components/shared/Locations3PP/Locations3PP";
import { SubmitRow } from "src/components/shared/StorefrontWizard/SubmitRow/SubmitRow";
import { OffersWithTransferToggle } from "./components/OffersWithTransferToggle";
import {
  UitkLayoutGrid,
  UitkLayoutConditionalGridSpan,
  UitkLayoutConditionalGridColumnRow,
} from "uitk-react-layout-grid";
import { LobErrorSummary } from "src/components/shared/LobErrorSummary/LobErrorSummary";
import { withLocalization } from "@shared-ui/localization-context";
import { TravelersTriggerTypes } from "src/components/shared/TravelersField/typings";
import { Wizard3ppPWAProps, Wizard3ppPWAFtNodeOptions } from "./typings";
import { normalizeOptionsData } from "src/stores/FlexTemplateStore";

@withLocalization
@observer
export class Wizard3ppPWAView extends React.Component<Wizard3ppPWAProps> {
  constructor(props: Wizard3ppPWAProps) {
    super(props);
  }

  componentDidMount() {
    const {
      wizardState: { thirdPartyPackageWizardState },
      context,
    } = this.props;

    if (context) {
      thirdPartyPackageWizardState.loadOrigins(context.site.id).then(() => {
        thirdPartyPackageWizardState.updateStateFromCookie();
        thirdPartyPackageWizardState.updateDateFromConfig();
      });
    }
  }

  public render() {
    const {
      wizardState: { thirdPartyPackageWizardState },
      context,
      flexModuleModelStore,
      flexTemplateNode,
      getLocError,
      setInputsRefs,
      l10n: { formatText },
    } = this.props;
    const { config: thirdConfig } = thirdPartyPackageWizardState;
    const { showGroupLink } = thirdConfig;
    const model = flexModuleModelStore.getModel(flexTemplateNode.id);
    const options = normalizeOptionsData(flexTemplateNode, model) as Wizard3ppPWAFtNodeOptions;

    const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 2, medium: 12 };
    const errorSummaryColSpan: UitkLayoutConditionalGridColumnRow = { small: 2, medium: 12 };
    const locationsColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 6 };
    const datesColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 3 };
    const durationColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 3 };
    const travelersColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 12 };
    const singleDate = thirdConfig.date.queryParam.end ? false : true;

    const { durationInvalidKey, numberOfErrors, moreThanOneError, errorInputRef } = thirdPartyPackageWizardState;

    const changeDuration = (selectEvent: React.ChangeEvent<HTMLSelectElement>) => {
      thirdPartyPackageWizardState.setDuration(selectEvent.target.value);
    };

    const isApiCallEnabled =
      context && thirdPartyPackageWizardState.config.siteIdsWithApiCall.includes(context.site.id);

    const globalConfig = this.props.wizardState.globalWizardState.config;

    return (
      <form
        noValidate={true}
        action={thirdPartyPackageWizardState.formAction}
        autoComplete="off"
        className="WizardThirdPartyPackagePWA"
        data-testid="wizard"
        onSubmit={thirdPartyPackageWizardState.submit}
        id={thirdConfig.elementId}
        data-fm={options.fmId}
        data-fm-title-id={options.fmTitleId}
      >
        {showGroupLink && (
          <div className="all-b-padding-four all-t-margin-one">
            <UitkSubheading>
              <UitkLink inline={true}>
                <a href="http://allinclusiveforgroups.expedia.ca/en-CA/LandGroup">
                  {formatText(thirdConfig.groupLinkKey, 10)}
                </a>
              </UitkLink>
            </UitkSubheading>
          </div>
        )}
        <UitkLayoutGrid columns={mainGridColumns} space="three">
          {numberOfErrors > 0 && (
            <LobErrorSummary
              locHeadingToken={getLocError!(false)!}
              locHeadingArgs={moreThanOneError() && [numberOfErrors]}
              locLinkToken={getLocError!(true)}
              linkClickFocusId="id-inclusive-error"
              inputErrorRef={errorInputRef}
              colSpan={errorSummaryColSpan}
              setInputsRefs={setInputsRefs}
            />
          )}
          <Travelers
            lobState={thirdPartyPackageWizardState}
            config={thirdConfig.travelers}
            colSpan={travelersColSpan}
            triggerType={TravelersTriggerTypes.LINK_BUTTON}
            isApiCallEnabled={isApiCallEnabled}
          />
          <Locations3PP lobState={thirdPartyPackageWizardState} colSpan={locationsColSpan} />
          <Dates
            singleDate={singleDate}
            lobState={thirdPartyPackageWizardState}
            colSpan={datesColSpan}
            setInputsRefs={setInputsRefs}
          />
          <Duration
            colSpan={durationColSpan}
            durations={thirdPartyPackageWizardState.durations}
            changeDuration={changeDuration}
            invalidDurationKey={durationInvalidKey}
            inputValue={thirdPartyPackageWizardState.duration}
            inputName={thirdConfig.duration.queryParam}
            placeholderKey={thirdConfig.duration.placeholderText}
          />
        </UitkLayoutGrid>
        {thirdConfig.offersWithTransfer.isVisible && (
          <OffersWithTransferToggle lobState={thirdPartyPackageWizardState} />
        )}

        <SubmitRow lobState={thirdPartyPackageWizardState} rfrr={"SearchClick_ThreePP"} globalConfig={globalConfig} />
      </form>
    );
  }
}
